import { render, staticRenderFns } from "./Plusgrade.vue?vue&type=template&id=8c0e0304&"
import script from "./Plusgrade.vue?vue&type=script&lang=js&"
export * from "./Plusgrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports